module.exports = __webpack_public_path__ + "static/media/create_contest_icon.446e88ba.svg";